export const styles = {
  menuItemContainer: {
    display: 'flex',
    gap: '24px',
    alignItems: 'center',
    width: '100%',
  },
};
